import React, { FunctionComponent } from 'react'

import { capitalize } from 'Helpers/layoutHelpers'
import { CampaignLanguagesProps } from './props'
import { GenresAndLanguagesRow } from './styles'

const CampaignLanguagesComponent: FunctionComponent<CampaignLanguagesProps> = ({
  languages,
}) => {
  const filteredLanguages = languages.filter(
    el => el.Language.language_name !== 'Any language'
  )

  const anyLangPresent = languages.find(
    el => el.Language.language_name === 'Any language'
  )

  return (
    <GenresAndLanguagesRow>
      {filteredLanguages.map((el, id) => {
        const languageToRender = `${capitalize(el.Language.language_name)}${
          id === filteredLanguages.length - 1 ? '' : ', '
        }`
        return languageToRender
      })}
      {!anyLangPresent && filteredLanguages.length ? ' (only)' : ''}
    </GenresAndLanguagesRow>
  )
}

export default CampaignLanguagesComponent
